import { render, staticRenderFns } from "./RecognitionDecisionForm.vue?vue&type=template&id=b9ef034a&scoped=true"
import script from "./RecognitionDecisionForm.vue?vue&type=script&lang=js"
export * from "./RecognitionDecisionForm.vue?vue&type=script&lang=js"
import style0 from "./RecognitionDecisionForm.vue?vue&type=style&index=0&id=b9ef034a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ef034a",
  null
  
)

export default component.exports